export function passwordValidator(value: string) {
  return (
    value &&
    !(
      value.length >= 8 &&
      value.match(/(?=.*[a-z])/) &&
      value.match(/(?=.*[A-Z])/) &&
      value.match(/(?=.*\d)/) &&
      value.match(/(?=.*[!%@#$%])/)
    )
  );
}
